module.exports = new __parcel__URL__("notes.fb6dd43b.png").toString();